angular.module('dnecom')
    .controller('EmailNotificationsController', ["$scope", "$http", "$timeout", "notifications", function ($scope, $http, $timeout, notifications) {
        $scope.store = TemplateData.value('store');
        $scope.notifications = TemplateData.value('notifications');
        $scope.loading = false;

        $scope.test = function(notification) {
            notification.isTesting = true;
            
            $http
                .get(Routing.generate('notifications_emails_test', {
                    'id' : $scope.store.id,
                    'notificationId' : notification.id || 0,
                    'type': notification.type
                }))
                .then(
                    function(response) {
                        if (!response.data.success) {
                            notifications.danger('Error while trying to send test message');
                            return;
                        }
                        notifications.success("Test email has been sent to " + $scope.store.email);
                    },
                    function(response) {
                        notifications.danger('Request error');
                    }
                )
                .finally(function() {
                    notification.isTesting = false;
                });
        };

        $scope.toggle = function(notification) {
            $http
                .get(Routing.generate('notifications_toggle', {
                    'id' : $scope.store.id,
                    'notificationId' : notification.id || 0,
                    'type': notification.type
                }))
                .success(function(response) {
                    if (!response.success) {
                        notifications.danger(response.message);
                        return;
                    }

                    notifications.success(response.message);
                }).finally($scope.getNotifications);
        };
        
        $scope.getNotifications = function() {
            $scope.loading = true;

            $http
                .get(Routing.generate('notifications_emails_get', {
                    'id' : $scope.store.id
                }))
                .success(function(response) {
                    if (!response.hasOwnProperty('notifications')) {
                        notifications.danger(response.message);
                        return;
                    }

                    $scope.notifications = response.notifications;
                })
                .finally(function() {
                    $timeout(function() {
                        $scope.loading = false;
                    });
                })
            ;
        };
    }]);
